import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { reactive, onMounted, toRefs, watch, watchEffect, getCurrentInstance, ref } from "vue";
import apis from "@/api";
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
export default {
  props: {
    id: String
  },
  components: {},
  setup(props, ctx) {
    let data = reactive({
      positionId: "",
      queryParam: {
        actName: "",
        assetsName: "",
        bgnDate_begin: "",
        endDate_end: ""
      },
      tabNum: "1",
      pageSize: 10,
      pageNo: 1,
      loading: true,
      tableData: [],
      tableTotal: 0,
      dateRange: '',
      defaultTime: [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]
    });
    const router = useRouter();
    const loadData = () => {
      data.loading = true;
      data.tableData = [];
      let params = Object.assign({}, data.queryParam, {
        positionId: data.positionId,
        tab: data.tabNum,
        pageNo: data.pageNo,
        pageSize: data.pageSize
      });
      apis.queryOffLPosBizList(params).then(res => {
        if (res.success) {
          data.tableData = res.data.pageList.records;
          data.tableTotal = res.data.pageList.total;
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    watch(() => props.id, id => {
      data.positionId = id;
      loadData();
    }, {
      immediate: true
    });
    const dateRangeChange = e => {
      data.queryParam.bgnDate_begin = dayjs(e[0]).format("YYYY-MM-DD HH:mm:ss");
      data.queryParam.endDate_end = dayjs(e[1]).format("YYYY-MM-DD HH:mm:ss");
    };
    const onSubmit = () => {
      loadData();
    };
    const reset = () => {
      data.queryParam = {
        actName: "",
        assetsName: "",
        bgnDate_begin: "",
        endDate_end: ""
      };
      data.dateRange = '';
      loadData();
    };
    const handleClick = (tab, event) => {
      data.tabNum = tab.props.name;
      loadData();
    };
    const showDetail = row => {
      router.push(`/operation/online/position-biz-info?id=${row.id}`);
    };
    const handleSizeChange = val => {
      console.log(`每页 ${val} 条`);
      data.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      console.log(`当前页: ${val}`);
      data.pageNo = val;
      loadData();
    };
    return {
      ...toRefs(data),
      onSubmit,
      reset,
      loadData,
      handleClick,
      handleSizeChange,
      handleCurrentChange,
      dateRangeChange,
      showDetail
    };
  }
};